import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface StyleProps {
  isOnMediaPage: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  controlPanelWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.background.paper,
  },
  leftSidePanel: {
    display: 'flex',
  },
  rightSidePanel: {
    display: 'flex',
  },
  firstButton: (props: StyleProps) => ({
    width: props.isOnMediaPage ? '80px' : '90px',
    fontSize: '9px',
    margin: '0 5px 0 0 ',
    '@media (max-width: 1600px)': {
      display: props.isOnMediaPage ? 'none' : 'unset',
    },
  }),
  lastButton: (props: StyleProps) => ({
    width: props.isOnMediaPage ? '80px' : '90px',
    fontSize: '9px',
    margin: '0 20px 0 0 ',
    '@media (max-width: 1600px)': {
      display: props.isOnMediaPage ? 'none' : 'unset',
    },
  }),
  firstLastButtons: {},
  goButton: (props: StyleProps) => ({
    width: props.isOnMediaPage ? '20px' : '90px',
    fontSize: '9px',
  }),
  downloadPdf: {},
  pageNumberText: (props: StyleProps) => ({
    color: theme.palette.primary.main,
    fontSize: props.isOnMediaPage ? '12px' : '14px',
  }),
  scaleAndSlider: (props: StyleProps) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1600px)': {
      display: props.isOnMediaPage ? 'none' : 'unset',
    },
  }),
  pdfTextFields: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  zoomInButton: (props: StyleProps) => ({
    '@media (max-width: 1600px)': {
      display: props.isOnMediaPage ? 'none' : 'unset',
    },
  }),
  zoomOutButton: (props: StyleProps) => ({
    '@media (max-width: 1600px)': {
      display: props.isOnMediaPage ? 'none' : 'unset',
    },
  }),
  zoomNumber: {
    color: theme.palette.primary.main,
  },
  printPDF: {
    display: 'flex',
    alignItems: 'center',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 12px',
  },
  searchField: {
    minWidth: '240px',
    '& .MuiOutlinedInput-root': {
      paddingRight: '4px',
      '& fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
}));

export default useStyles;
